module.exports = __webpack_public_path__ + "static/media/header-image-01.4c172aee.png";